import { FileVersion, FileVersionPost } from '@brandfolder/types';
import {
  Attachment,
  AttachmentListResultSet,
  attachmentsMockData,
  Container,
  IAttachmentRepo,
  ListOptions,
  mockVersion,
  mockVersions,
  PagedResults,
} from '@integration-frontends/integration/core/model';

export class AttachmentRepoMock implements IAttachmentRepo {
  getAssetAttachment = (assetId: string): Promise<Attachment> => {
    return Promise.resolve(attachmentsMockData[0]);
  };

  getAttachment(attachmentId: string): Promise<Attachment> {
    return Promise.resolve(attachmentsMockData[0]);
  }

  listAssetAttachments(assetId: string): Promise<Attachment[]> {
    return Promise.resolve(attachmentsMockData);
  }

  listContainerAttachments(
    container: Container,
    options: ListOptions,
  ): Promise<PagedResults<AttachmentListResultSet>> {
    return Promise.resolve({
      data: {
        attachments: attachmentsMockData,
      },
      totalCount: attachmentsMockData.length,
      totalPages: Math.ceil(attachmentsMockData.length / 48),
      perPage: attachmentsMockData.length,
      nextPage: options.pagination.nextPage || null,
      currentPage: options.pagination.page || 1,
    });
  }

  getAttachmentVersions(attachmentId: string): Promise<FileVersion[]> {
    return Promise.resolve(mockVersions);
  }

  postAttachmentVersion(attachmentId: string, attributes: FileVersionPost): Promise<FileVersion> {
    return Promise.resolve(mockVersion);
  }
}

export function createMockAttachmentResponse(
  overrides: Partial<PagedResults<AttachmentListResultSet>> = {},
): PagedResults<AttachmentListResultSet> {
  return {
    data: {
      attachments: attachmentsMockData,
    },
    totalCount: overrides?.data?.attachments?.length || attachmentsMockData.length,
    totalPages: Math.ceil(attachmentsMockData.length / 48),
    perPage: overrides?.data?.attachments?.length || attachmentsMockData.length,
    nextPage: null,
    currentPage: 1,
    ...overrides,
  };
}
